export const SEATS_VERSIONS_FEATURE_FLAG = 'SEATS_VERSIONS_FEATURE_FLAG';
export const CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_FLAG = 'CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_FLAG';
export const CBX_FEATURE_STORE_DEFAULT_CONTENT_FLAG = 'CBX_FEATURE_STORE_DEFAULT_CONTENT_FLAG';
export const CBX_CLEARBIT_FLAG = 'CBX_CLEARBIT_FLAG';